import { useQueryGetReportList } from 'api/queries/getReportList.query';
import { useQueryGetReportsTags } from 'api/queries/getReportsTags.query';

export type UseReportsTableProvider = ReturnType<typeof useReportsTableProvider>;

export const useReportsTableProvider = () => {
    return {
        api: {
            getReportList: useQueryGetReportList(getGetReportListPayload()),
            getTagList: useQueryGetReportsTags(),
        },
    };
};

const getGetReportListPayload = () => {
    return {
        filter: {
            filters: [],
        },
    };
};
